import { LOOKUP, KICKSTART_RESPONSES } from 'utils/constants/collectionNames';
import { CHAT_PRESETS } from 'utils/constants/lookup';
import { MESSAGES_PAGE } from 'utils/constants/messages';
import * as firebase from 'firebase/app';
import 'firebase/firestore';
import Chat from 'twilio-chat';
import {
  GET_CHANNELS_SUCCEEDED,
  GET_CHANNELS_ERROR,
  READ_STATUS_UPDATED,
  GET_CHAT_PRESETS_SUCCEEDED,
  GET_CHAT_PRESETS_ERROR,
  CHECK_KICKSTART_SUCCEEDED,
  CHECK_KICKSTART_ERROR,
  GET_MESSAGES_FIRST_PAGE_SUCCEEDED,
  GET_MESSAGES_FIRST_PAGE_ERROR,
  GET_MESSAGES_PREV_PAGE_SUCCEEDED,
  GET_MESSAGES_PREV_PAGE_ERROR,
  MESSAGE_ADDED,
  CHANNEL_ADDED,
  CHANNEL_REMOVED,
  START_LOADING_MESSAGES
} from './types';

export const getChannels = () => async dispatch => {
  let getTwilioAccessToken = firebase
    .functions()
    .httpsCallable('chatGetTwilioAccessToken');

  getTwilioAccessToken()
    .then(token => {
      Chat.create(token.data)
        .then(chatClient => {
          setChatClientEvents(chatClient, dispatch);

          chatClient
            .getUserChannelDescriptors()
            .then(async paginator => {
              var channels = [];
              for (var i = 0; i < paginator.items.length; i++) {
                var fullChannel = await paginator.items[i].getChannel();
                if (!fullChannel.sid) throw new Error(fullChannel);

                // get last message if exist
                if (fullChannel.lastMessage) {
                  var page = await fullChannel.getMessages(1);
                  fullChannel.lastMessageObj = page.items && {
                    index: page.items[0].index,
                    body: page.items[0].body,
                    timestamp: page.items[0].timestamp
                  };
                }
                channels.push(fullChannel);
              }
              dispatch({
                type: GET_CHANNELS_SUCCEEDED,
                payload: channels
              });
            })
            .catch(err => {
              throw new Error(err);
            });
        })
        .catch(err => {
          throw new Error(err);
        });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_CHANNELS_ERROR,
        payload: `error: ${err}`
      });
    });
};

export const getChatPresets = () => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore.collection(LOOKUP).doc(CHAT_PRESETS);

  docRef
    .get()
    .then(doc => {
      if (doc.exists) {
        dispatch({
          type: GET_CHAT_PRESETS_SUCCEEDED,
          payload: {
            ...doc.data().values
          }
        });
      }
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_CHAT_PRESETS_ERROR,
        payload: `error: ${err}`
      });
    });
};

export const checkKickstart = clientId => async dispatch => {
  let firestore = firebase.firestore();
  const docRef = firestore.collection(KICKSTART_RESPONSES).doc(clientId);

  docRef
    .get()
    .then(doc => {
      dispatch({
        type: CHECK_KICKSTART_SUCCEEDED,
        payload: doc.exists
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: CHECK_KICKSTART_ERROR,
        payload: `error: ${err}`
      });
    });
};

// Get messages from the newest to oldest
export const getMessagesFirstPage = channel => async dispatch => {
  dispatch({
    type: START_LOADING_MESSAGES
  });
  channel
    .getMessages(MESSAGES_PAGE)
    .then(messagesPage => {
      messagesPage.items.length &&
        channel.updateLastConsumedMessageIndex(
          messagesPage.items[messagesPage.items.length - 1].index
        );
      dispatch({
        type: GET_MESSAGES_FIRST_PAGE_SUCCEEDED,
        payload: { page: messagesPage, currentChannelSid: channel.sid }
      });
    })
    .catch(err => {
      console.log(err);
      dispatch({
        type: GET_MESSAGES_FIRST_PAGE_ERROR,
        payload: `error: ${err}`
      });
    });
};

// Get messages previous page
export const getMessagesPrevPage = page => async dispatch => {
  if (page.hasPrevPage) {
    page
      .prevPage()
      .then(messagesPage => {
        dispatch({
          type: GET_MESSAGES_PREV_PAGE_SUCCEEDED,
          payload: messagesPage
        });
      })
      .catch(err => {
        console.log(err);
        dispatch({
          type: GET_MESSAGES_PREV_PAGE_ERROR,
          payload: `error: ${err}`
        });
      });
  }
};

export const setChatClientEvents = (chatClient, dispatch) => {
  chatClient.on('channelUpdated', res => {
    if (res.updateReasons.includes('lastConsumedMessageIndex'))
      dispatch({
        type: READ_STATUS_UPDATED,
        payload: res.channel
      });
  });

  chatClient.on('channelAdded', channel => {
    setChannelEvents(channel, dispatch);
    dispatch({
      type: CHANNEL_ADDED,
      payload: channel
    });
  });

  chatClient.on('channelRemoved', channel => {
    dispatch({
      type: CHANNEL_REMOVED,
      payload: channel
    });
  });
};

export const setChannelEvents = (channel, dispatch) => {
  channel.on('messageAdded', message => {
    message.channel.lastMessageObj = {
      index: message.index,
      body: message.body,
      timestamp: message.timestamp
    };
    dispatch({
      type: MESSAGE_ADDED,
      payload: message
    });
  });
};
